import { render } from "./InfoPage.vue?vue&type=template&id=5ace44ff"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__